import React from 'react';
import PropTypes from 'prop-types';

const DraftUserCard = ({ userId, user, draftEntry }) => (
  <div className="draft-user-card mb-3">
    <div className="draft-user-card__header d-flex align-items-center justify-content-between">
      <div>
        <span className="draft-user-card__name">{user.displayName}</span>
        <span className="draft-user-card__email ml-3">{user.email}</span>
      </div>
      <div className="d-flex align-items-center">
        {draftEntry.draftInPerson && (
          <span className="badge badge-success mr-3">In Person</span>
        )}
        <span className="draft-user-card__id">{userId}</span>
      </div>
    </div>

    <div className="draft-user-card__body d-flex flex-wrap">
      <div className="draft-user-card__section">
        <span className="draft-user-card__label">Team Name</span>
        <span className="draft-user-card__value">{draftEntry.teamName || <em className="text-mute">Not set</em>}</span>
      </div>

      <div className="draft-user-card__section">
        <span className="draft-user-card__label">Last Login</span>
        <span className="draft-user-card__value">{user.lastLogin || '—'}</span>
      </div>

      {(draftEntry.logoUrl || draftEntry.logoUpload) && (
        <div className="draft-user-card__section">
          <span className="draft-user-card__label">Logo</span>
          <div className="draft-user-card__value">
            {draftEntry.logoUrl && draftEntry.logoUrl !== '' && (
              <a href={draftEntry.logoUrl} target="_image">
                <img src={draftEntry.logoUrl} alt="Team Logo" className="draft-user-card__logo" />
              </a>
            )}
            {draftEntry.logoUpload && draftEntry.logoUploadFilename && (
              <span className="draft-user-card__filename">{draftEntry.logoUploadFilename}</span>
            )}
          </div>
        </div>
      )}

      {draftEntry.songList && draftEntry.songList.length > 0 && (
        <div className="draft-user-card__section draft-user-card__section--wide">
          <span className="draft-user-card__label">Songs ({draftEntry.songList.length})</span>
          <ol className="draft-user-card__songs">
            {draftEntry.songList.map((song, songIndex) => (
              <li key={songIndex}>
                {song.songTitle}
                {song.songUrl && (
                  <a href={song.songUrl} target="_song" className="ml-2 draft-user-card__song-link">
                    Link
                  </a>
                )}
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  </div>
);

DraftUserCard.propTypes = {
  userId: PropTypes.string.isRequired,
  user: PropTypes.shape({
    displayName: PropTypes.string,
    email: PropTypes.string,
    lastLogin: PropTypes.string,
  }).isRequired,
  draftEntry: PropTypes.shape({
    teamName: PropTypes.string,
    draftInPerson: PropTypes.bool,
    logoUrl: PropTypes.string,
    logoUpload: PropTypes.bool,
    logoUploadFilename: PropTypes.string,
    songList: PropTypes.arrayOf(PropTypes.shape({
      songTitle: PropTypes.string,
      songUrl: PropTypes.string,
    })),
  }).isRequired,
};

export default DraftUserCard;
